/* eslint-disable @typescript-eslint/naming-convention */

export enum VcrCommand {
  Logout = 'logout',
  PingVcr = 'vcr-ping-vcr',
  SelectGroup = 'vcr-select-group-by-portal-id',
  ShareProblemById = 'vcr-share-problem', /* @TODO change value to vcr-share-problem-by-id */
  ShareProblemByURL = 'vcr-share-problem-by-url',
  OpenAssignment = 'vcr-open-assignment',
  LoadAssignment = 'vcr-load-assignment',
  UnloadAssignment = 'vcr-unload-assignment',
  PublishAssignment = 'vcr-publish-assignment',
  UnpublishAssignment = 'vcr-unpublish-assignment',
  GradeAssignment = 'vcr-grade-assignment',
  GradeAndCloseAssignment = 'vcr-grade-and-close-assignment',
  VcrWindowIsLoaded = 'vcr-window-is-loaded',
}

export enum WebPortalMessageType {
  Request = 'request',
  Response = 'response',
  Event = 'event'
}

export enum SourceApp {
  Classroom = 'Classroom',
  Vcr = 'Vcr',
  AssignmentMgr = 'AssignmentMgr'
}

export enum ResponseStatus {
  Success = 'success',
  Error = 'error'
}
